import {
  mutableListOf6oorvk2mtdmp as mutableListOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './collections/CollectionsKt.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from './Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import {
  indexOfwa4w6635jewi as indexOf,
  lineSequencefj20mplblw0p as lineSequence,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
} from './text/Strings.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from './js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from './Char.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from './collections/collectionJs.mjs';
import { dropLastlqc2oyv04br0 as dropLast } from './text/_Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './text/StringBuilderJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function addSuppressed(_this__u8e3s4, exception) {
  if (!(_this__u8e3s4 === exception)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var suppressed = _this__u8e3s4._suppressed;
    if (suppressed == null) {
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4._suppressed = mutableListOf([exception]);
    } else {
      suppressed.i2(exception);
    }
  }
}
function stackTraceToString(_this__u8e3s4) {
  return (new (ExceptionTraceBuilder())()).nh(_this__u8e3s4);
}
function hasSeen($this, exception) {
  var tmp0 = $this.kh_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.any' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element === exception) {
        tmp$ret$0 = true;
        break $l$block;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function dumpFullTrace($this, $receiver, indent, qualifier) {
  if (!dumpSelfTrace($this, $receiver, indent, qualifier))
    return Unit_instance;
  var cause = $receiver.cause;
  while (!(cause == null)) {
    if (!dumpSelfTrace($this, cause, indent, 'Caused by: '))
      return Unit_instance;
    cause = cause.cause;
  }
}
function dumpSelfTrace($this, $receiver, indent, qualifier) {
  $this.jh_1.m1(indent).m1(qualifier);
  var shortInfo = $receiver.toString();
  if (hasSeen($this, $receiver)) {
    $this.jh_1.m1('[CIRCULAR REFERENCE, SEE ABOVE: ').m1(shortInfo).m1(']\n');
    return false;
  }
  // Inline function 'kotlin.js.asDynamic' call
  $this.kh_1.push($receiver);
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = $receiver.stack;
  var stack = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
  if (!(stack == null)) {
    // Inline function 'kotlin.let' call
    var it = indexOf(stack, shortInfo);
    var stackStart = it < 0 ? 0 : it + shortInfo.length | 0;
    if (stackStart === 0) {
      $this.jh_1.m1(shortInfo).m1('\n');
    }
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = $this.lh_1;
    if (charSequenceLength(this_0) === 0) {
      $this.lh_1 = stack;
      $this.mh_1 = stackStart;
    } else {
      stack = dropCommonFrames($this, stack, stackStart);
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(indent) > 0) {
      var tmp_0;
      if (stackStart === 0) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.text.count' call
        var count = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(shortInfo)) {
          var element = charSequenceGet(shortInfo, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (element === _Char___init__impl__6a9atx(10)) {
            count = count + 1 | 0;
          }
        }
        tmp_0 = 1 + count | 0;
      }
      var messageLines = tmp_0;
      // Inline function 'kotlin.sequences.forEachIndexed' call
      var index = 0;
      var _iterator__ex2g4s = lineSequence(stack).p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        if (checkIndexOverflow(_unary__edvuaz) >= messageLines) {
          $this.jh_1.m1(indent);
        }
        $this.jh_1.m1(item).m1('\n');
      }
    } else {
      $this.jh_1.m1(stack).m1('\n');
    }
  } else {
    $this.jh_1.m1(shortInfo).m1('\n');
  }
  var suppressed = get_suppressedExceptions($receiver);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!suppressed.n1()) {
    var suppressedIndent = indent + '    ';
    var _iterator__ex2g4s_0 = suppressed.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var s = _iterator__ex2g4s_0.r1();
      dumpFullTrace($this, s, suppressedIndent, 'Suppressed: ');
    }
  }
  return true;
}
function dropCommonFrames($this, stack, stackStart) {
  var commonFrames = 0;
  var lastBreak = 0;
  var preLastBreak = 0;
  var inductionVariable = 0;
  var tmp0 = $this.lh_1.length - $this.mh_1 | 0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b = stack.length - stackStart | 0;
  var last = Math.min(tmp0, b);
  if (inductionVariable < last)
    $l$loop: do {
      var pos = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = charCodeAt(stack, get_lastIndex(stack) - pos | 0);
      if (!(c === charCodeAt($this.lh_1, get_lastIndex($this.lh_1) - pos | 0)))
        break $l$loop;
      if (c === _Char___init__impl__6a9atx(10)) {
        commonFrames = commonFrames + 1 | 0;
        preLastBreak = lastBreak;
        lastBreak = pos;
      }
    }
     while (inductionVariable < last);
  if (commonFrames <= 1)
    return stack;
  while (preLastBreak > 0 && charCodeAt(stack, get_lastIndex(stack) - (preLastBreak - 1 | 0) | 0) === _Char___init__impl__6a9atx(32))
    preLastBreak = preLastBreak - 1 | 0;
  return dropLast(stack, preLastBreak) + ('... and ' + (commonFrames - 1 | 0) + ' more common stack frames skipped');
}
var ExceptionTraceBuilderClass;
function ExceptionTraceBuilder() {
  if (ExceptionTraceBuilderClass === VOID) {
    class $ {
      constructor() {
        this.jh_1 = StringBuilder().l1();
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.kh_1 = [];
        this.lh_1 = '';
        this.mh_1 = 0;
      }
      nh(exception) {
        dumpFullTrace(this, exception, '', '');
        return this.jh_1.toString();
      }
    }
    initMetadataForClass($, 'ExceptionTraceBuilder', ExceptionTraceBuilder);
    ExceptionTraceBuilderClass = $;
  }
  return ExceptionTraceBuilderClass;
}
function get_suppressedExceptions(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = _this__u8e3s4._suppressed;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tmp0_safe_receiver;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
}
//region block: exports
export {
  addSuppressed as addSuppressedu5jwjfvsc039,
  stackTraceToString as stackTraceToString2670q6lbhdojj,
};
//endregion

//# sourceMappingURL=throwableExtensions.mjs.map
